import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import { Controller, type ControllerProps, type FieldValues, type Path, useFormContext } from 'react-hook-form';
import TextArea, { type TextAreaProps } from '../../text-area';
import type { LabelTooltipProps } from '../internals/form-label';
import FormWrapper from '../internals/form-wrapper';
export type FormTextareaProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  label?: string | React.ReactNode;
  rules?: ControllerProps<TFieldValues>['rules'];
  tooltip?: LabelTooltipProps;
  size?: 'default' | 'compact';
  errorPosition?: 'absolute' | 'relative';
  orientation?: 'vertical' | 'horizontal';
  hideError?: boolean;
} & Omit<TextAreaProps, 'value' | 'ref' | 'label' | 'hasError'>;
export default function FormTextarea(t0) {
  const $ = _c(27);
  let baseId;
  let hint;
  let label;
  let name;
  let rules;
  let t1;
  let t2;
  let t3;
  let t4;
  let textareaProps;
  let tooltip;
  if ($[0] !== t0) {
    ({
      name,
      label,
      rules,
      hint,
      id: baseId,
      tooltip,
      size: t1,
      errorPosition: t2,
      orientation: t3,
      hideError: t4,
      ...textareaProps
    } = t0);
    $[0] = t0;
    $[1] = baseId;
    $[2] = hint;
    $[3] = label;
    $[4] = name;
    $[5] = rules;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = textareaProps;
    $[11] = tooltip;
  } else {
    baseId = $[1];
    hint = $[2];
    label = $[3];
    name = $[4];
    rules = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    textareaProps = $[10];
    tooltip = $[11];
  }
  const size = t1 === undefined ? "default" : t1;
  const errorPosition = t2 === undefined ? "relative" : t2;
  const orientation = t3 === undefined ? "vertical" : t3;
  const hideError = t4 === undefined ? false : t4;
  const {
    control
  } = useFormContext();
  const contextId = useId();
  const id = baseId || contextId;
  let t5;
  if ($[12] !== errorPosition || $[13] !== hideError || $[14] !== hint || $[15] !== id || $[16] !== label || $[17] !== orientation || $[18] !== size || $[19] !== textareaProps || $[20] !== tooltip) {
    t5 = t6 => {
      const {
        field,
        fieldState
      } = t6;
      const error = fieldState.error?.message;
      return <FormWrapper hideError={hideError} id={id} error={error} label={label} errorPosition={errorPosition} size={size} hint={hint} orientation={orientation} fullWidth={true} disabled={textareaProps.disabled} tooltip={tooltip}><TextArea {...textareaProps} {...field} size={size} onChange={e => {
          field.onChange(e);
          textareaProps.onChange?.(e);
        }} hasError={!!error} id={id} disabled={field.disabled || textareaProps.disabled} data-dd-privacy="mask" /></FormWrapper>;
    };
    $[12] = errorPosition;
    $[13] = hideError;
    $[14] = hint;
    $[15] = id;
    $[16] = label;
    $[17] = orientation;
    $[18] = size;
    $[19] = textareaProps;
    $[20] = tooltip;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== control || $[23] !== name || $[24] !== rules || $[25] !== t5) {
    t6 = <Controller name={name} control={control} rules={rules} render={t5} />;
    $[22] = control;
    $[23] = name;
    $[24] = rules;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
}